export enum DiscoverEvents {
    CLICK_MARKET_SUMMARY_ITEM = 'DISCOVER:click_market_summary_item',
    CLICK_CATEGORY = 'DISCOVER:click_category',
    CLICK_CATEGORY_ASSET = 'DISCOVER:click_category_asset',
    CLICK_NEWS_ITEM = 'DISCOVER:click_news_item',
    CLICK_MORE_NEWS = 'DISCOVER:click_more_news',
    CLICK_TOP_GAINERS_SHOW_MORE = 'DISCOVER:click_top_gainers_show_more',
    CLICK_TOP_LOSERS_SHOW_MORE = 'DISCOVER:click_top_losers_show_more',
    VIEWED_PAGE = 'DISCOVER:viewed_page',
    SEARCH_QUERY = 'DISCOVER:search_query',
    CLICK_SEARCH_RESULT = 'DISCOVER:click_search_result',
}
